import Link from 'next/link'

import { Banner, BannerAction, BannerDescription } from '@wartek-id/banner'
import { Button } from '@wartek-id/button-v1'

import { PENGELOLAAN_KINERJA_RIWAYAT_PATH } from 'app/KinerjaShared/constants/path'

export default function BannerNewAsn() {
  return (
    <Banner
      title="Info Penting: Ada penyesuaian pada data periode Pengelolaan Kinerja Anda"
      type="informational"
    >
      <BannerDescription className="!text-base !text-default">
        Ini terjadi karena Anda baru memperoleh Penugasan JF Guru. Cek Riwayat
        untuk memeriksa data periode yang terdampak.
      </BannerDescription>
      <BannerAction>
        <Link passHref href={PENGELOLAAN_KINERJA_RIWAYAT_PATH}>
          <Button
            as="a"
            className="!bg-transparent !inline-block"
            color="white"
            size="sm"
            type={undefined}
          >
            Cek Riwayat
          </Button>
        </Link>
      </BannerAction>
    </Banner>
  )
}
